// The Intl locale for an app locale. Our Serbian is Latin script; Intl's bare
// "sr" is Cyrillic.
export function intlLocale(locale) {
  if (!locale) return undefined
  return locale === "sr" ? "sr-Latn" : locale
}
